import { Avatar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Autocomplete } from '../../../components/Forms/Autocomplete';
import { getTeamMembers, newUserAccount } from '../../../redux/Account/account.actions';
import { FullAccount } from '../../../redux/Account/account.selectors';
import { openToast } from '../../../redux/UI/ui.actions';
import { getInitials, isEmail } from '../../../services/Utils';
import { HorizontalStack, SmartContainer, Stack, Surface } from '../../../styles/Containers';
import { StyledTab, StyledTabPanel, StyledTabs } from '../../../styles/matieralui/Tabs';
import { StyledP } from '../../../styles/StyledHTML';
import { PermissionUser } from './PermissionUser';
import { createPermission, searchPermissions } from './redux/permissions.actions';
import { FormInput } from '../../../components/Forms/FormInput';
import { FormSelect } from '../../../components/Forms/FormSelect';
import { StyledButton } from '../../../styles/matieralui/Button';
import { FullNetwork } from '../../../redux/Network/network.selectors';
import { FullPermissions } from './redux/permissions.selectors';
import { FullLibraries } from '../Library/redux/library.selectors';
import { searchLibrary } from '../Library/redux/library.actions';

export const usePermissionsForUser = () => {
    const dispatch = useDispatch();
    const store = FullPermissions();
    const storeLibraries = FullLibraries();
    const [user, setUser] = useState();
    const [perm, setPerm] = useState([]);


    const getUserPermissions = () => {
        if (!user) return;
        const uP = store?.items?.rows?.filter(p => {
            if (p.UserId === user.id) {
                const found = storeLibraries?.items?.rows?.find(item => {
                    if (item?.id === p.modelId) {
                        p.library = item;

                        return item;
                    } else {

                        return false;
                    }
                })
                if (found) return found;

            } else {
                return false;
            }
        });
        setPerm(uP);

    }

    useEffect(() => {
        dispatch(searchLibrary(0, 999, null, null, {}))
    }, [])

    useEffect(() => {
        if (!user) return;
        // Get All Permissions for this ModelID
        const args = { UserId: `[${user.id}]` }
        dispatch(searchPermissions(0, 999, null, null, args))
        // TODO: We can't search by UserId for permission reasons...

    }, [user])

    useEffect(() => {
        if (store.updateSuccess) {
            dispatch(openToast('Updated Permission', 'success'));
            getUserPermissions();
        }
    }, [store.updateSuccess])

    useEffect(() => {
        if (store.deleteSuccess) {
            // Display Success
            dispatch(openToast('Permission Deleted', 'success'));
            getUserPermissions();
        }
        if (store.deleteError) {
            dispatch(openToast('Error: Permission not deleted.', 'error'));
            getUserPermissions();
        }
    }, [store.deleteLoading])

    useEffect(() => {

        getUserPermissions();

    }, [store?.items])

    return {
        setUser,
        userPermissions: perm,
    }
}



export const usePermissionsManager = ({ model, modelId, selector, action, args = {} }) => {
    const dispatch = useDispatch();
    const store = selector();
    const fullAccount = FullAccount();
    const fullNetwork = FullNetwork();
    const [activeMembers, setActiveMembers] = useState([]);
    const [inactiveMembers, setInactiveMembers] = useState([]);
    const [isNewMember, setIsNewMember] = useState(false);
    const formatMembers = () => {
        if (!fullAccount?.team) return;
        let inactive = [];
        const withAccess = fullAccount?.team.filter(user => {
            // Owners & Admins always have access
            if (user?.role === 'admin' || user?.role === 'owner') return user;
            else {
                if (store?.items && store?.items?.count > 0) {
                    const found = store?.items?.rows?.find(item => {
                        if (item?.UserId === user.id) {
                            user.role = item.role;
                            user.permissionId = item.id;
                            return user;
                        } else {

                            return false;
                        }
                    })
                    if (found) return found;
                    else inactive.push(user);
                } else {
                    inactive.push(user);
                }


            }
        })
        setInactiveMembers(inactive);
        setActiveMembers(withAccess);
    }

    const createThePermission = (userId, roleName) => {

        const args = {
            modelType: model,
            modelId: modelId,
            UserId: userId,
            role: (roleName) ? roleName : 'viewer'
        }

        dispatch(createPermission(args))
    }
    // Get All Permissions for this Model
    useEffect(() => {


        // Get All Permissions for this ModelID
        const args = {}
        args.modelType = `["${model}"]`;
        args.modelId = `["${modelId}"]`;

        // Load Permissions If they Dont match
        if (args.modelType !== store?.itemsArgs?.modelType || args.modelId !== store?.itemsArgs?.modelId) {
            dispatch(action(0, 999, null, null, args))
        }

        formatMembers();

    }, [model, modelId])

    // Get All The Team Members on This Account
    useEffect(() => { if (fullAccount.account?.id) dispatch(getTeamMembers(fullAccount.account.id)) }, [fullAccount.account])

    // Format The Team Members
    useEffect(() => { formatMembers() }, [fullAccount?.team])

    // On Permission Creations Notifications
    useEffect(() => {
        if (store.createSuccess) {
            dispatch(openToast('User added.', 'success'));

        }
        if (store.deleteSuccess) {
            dispatch(openToast('User removed.', 'success'));

        }
        if (store.updateSuccess) {
            dispatch(openToast('User Access Updated.', 'success'));

        }
        formatMembers();
    }, [store])

    // New Team Member Notification
    useEffect(() => {
        if (fullAccount.addTeamMemberSuccess) {
            // -- Display Successful User Add
            dispatch(openToast(fullAccount.addTeamMemberSuccess, 'success'))
            // -- Add User to this Library
            if (args.withCreatePermission === true) {
                const newPerson = fullAccount.addTeamMember;
                createThePermission(newPerson.id, newPerson.role);
            }
            //-- Reset
            setIsNewMember(false);

        }
        if (fullAccount.addTeamMemberError) {
            dispatch(openToast(fullAccount.addTeamMemberError, 'error'))

        }
    }, [fullAccount?.addTeamMemberLoading]);


    return {
        storePermissions: store,
        activeMembers,
        inactiveMembers,
        isNewMember,
        setIsNewMember,
        createThePermission
    }
}


export const PermissionsManager = ({ model, modelId, selector, action }) => {

    const dispatch = useDispatch();
    const fullAccount = FullAccount();
    const fullNetwork = FullNetwork();

    const [open, setOpen] = useState(false);
    const [invite, setInvite] = useState('');
    const [inviting, setInviting] = useState([]);

    const [role, setRole] = useState('viewer');
    const [emailError, setEmailError] = useState('');
    const [name, setName] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, index) => setActiveTab(index);

    const { storePermissions, activeMembers, inactiveMembers, setIsNewMember, isNewMember, createThePermission } = usePermissionsManager({ model, modelId, selector, action, args: { withCreatePermission: true } });


    const renderActiveMembers = () => {
        if (!activeMembers) return null;
        return activeMembers.map(user => {
            return (
                <PermissionUser user={user} />
            )
        })
    }

    const renderInviting = () => {
        if (!inviting) return null;
        return inviting.map(user => {
            return (
                <PermissionUser user={user} />
            )
        })
    }

    const handleEmailChange = (email) => {
        setInvite(email);
        if (isEmail(email)) setEmailError('')
        else setEmailError('Please enter a valid email')

    }

    const handleInviteEmail = (item) => {
        if (!item) return;
        setIsNewMember(true);
        handleEmailChange(item);
    }

    const sendEmailInvite = () => {
        // Create A New User On This Account
        dispatch(newUserAccount(fullNetwork.network.id, fullAccount.account.id, name, invite, role));
    }



    const handleInviteSelection = (item) => {
        createThePermission(item.id, item?.role);
    }

    return (
        <SmartContainer thinking={fullAccount?.addTeamMemberLoading}>
            <Surface variant="inverse">
                <StyledTabs indicatorColor="primary" value={activeTab} onChange={handleTabChange} aria-label="Edit Form" scrollButtons="auto">
                    <StyledTab label="Members" id="screen-1" key="screen-1" aria-controls="screen-1" />
                    <StyledTab label="Invite" id="screen-2" key="screen-2" aria-controls="screen-2" />
                </StyledTabs>

                <StyledP>&nbsp;</StyledP>
                <StyledTabPanel value={activeTab} index={0}>
                    <Stack data-active-members maxHeight="50vh" overflow="scroll">{renderActiveMembers()}</Stack>
                </StyledTabPanel>

                <StyledTabPanel value={activeTab} index={1}>

                    <Stack>
                        {renderInviting()}
                        {!isNewMember && (
                            <Autocomplete
                                label="Search or invite"
                                options={inactiveMembers}
                                optionLabelKey="email"
                                onChange={handleInviteSelection}
                                value={invite}
                                type="text"
                                noOptionsTextAction={handleInviteEmail}
                                noOptionsText="Invite User"
                            />)}
                        {isNewMember && (
                            <Stack>
                                <FormInput label="email" type="email" value={invite} onChange={handleEmailChange} helperText={emailError} error={(emailError)} />
                                <FormInput label="name" type="text" value={name} onChange={setName} />
                                <FormSelect label="Access" value={role} onChange={setRole}>
                                    <option key="viewer" value="viewer">Viewer</option>
                                    <option key="editor" value="editor">Collaborator</option>
                                </FormSelect>
                                <StyledButton disabled={(emailError || !name)} variant="contained" onClick={sendEmailInvite}>Send Invite</StyledButton>
                            </Stack>
                        )}
                    </Stack>
                </StyledTabPanel>
            </Surface>
        </SmartContainer>
    )
}